export enum EnvironmentType {
  Local,
  Development,
  QA,
  Staging,
  Beta,
  Sandbox,
  Production,
  TekfiveSandbox,
  HlmaSandbox
}
